import { useEffect, useRef, useState } from 'react';

// One lightweight live connection; server only sends "changed" signals, data is re-fetched via REST.
export default function useRecoveryLive({ planId, onChange, enabled = true }) {
  const [live, setLive] = useState(false);
  const cb = useRef(onChange);
  cb.current = onChange;

  useEffect(() => {
    if (!enabled) return undefined;
    let ws; let retry; let ping; let stopped = false; let attempt = 0;
    const connect = () => {
      const token = localStorage.getItem('token');
      if (!token) return;
      const base = process.env.REACT_APP_BACKEND_URL.replace(/^http/, 'ws');
      const q = new URLSearchParams({ token, ...(planId ? { plan_id: planId } : {}) });
      ws = new WebSocket(`${base}/api/ws/recovery?${q}`);
      ws.onopen = () => {
        setLive(true);
        if (attempt > 0) cb.current?.();
        attempt = 0;
        ping = setInterval(() => { try { ws.send('ping'); } catch { /* closed */ } }, 25000);
      };
      ws.onmessage = (e) => { try { if (JSON.parse(e.data).type === 'changed') cb.current?.(); } catch { /* ignore */ } };
      ws.onclose = () => {
        setLive(false); clearInterval(ping);
        if (!stopped) { attempt += 1; retry = setTimeout(connect, Math.min(30000, 1500 * attempt)); }
      };
    };
    connect();
    const onVis = () => { if (document.visibilityState === 'visible') cb.current?.(); };
    document.addEventListener('visibilitychange', onVis);
    return () => { stopped = true; clearTimeout(retry); clearInterval(ping); document.removeEventListener('visibilitychange', onVis); try { ws?.close(); } catch { /* noop */ } };
  }, [planId, enabled]);

  return live;
}
